import { useContext } from 'react'

import { type Breakpoint } from '../provider/MediaGuard'
import MediaContext, { type MediaContextType } from '../provider/MediaGuardContext'

function useMediaContext(): MediaContextType {
  const context = useContext(MediaContext)
  if (context === undefined) {
    throw new Error('useMediaContext must be used within a MediaGuard')
  }
  return context
}

export function useMediaQuery(breakpoint: Breakpoint): boolean {
  const { matches } = useMediaContext()
  return matches[breakpoint]
}

export function useIsWideLayout(): boolean {
  return useMediaQuery('lg')
}

export function useIsTablet(): boolean {
  const isDesktop = useIsDesktop()
  return useMediaQuery('lg') && !isDesktop
}

function useIsDesktop(): boolean {
  return useMediaQuery('xl')
}